import ModelUtil from '@leverege/model-util';
import StringUtil from '@leverege/string-util';
import { FilterSourceModel } from "../../../../filters/index.js";
const imagineType = 'filter';
const TYPE = `aggregation.${imagineType}`;
function create(extend) {
  return {
    type: TYPE,
    filter: FilterSourceModel.create(),
    ...extend
  };
}
function getValueType(model) {
  return 'count';
}
export default {
  create,
  TYPE,
  name: StringUtil.camelCaseToTitleCase(imagineType),
  ...ModelUtil.createAllValue('filter'),
  getValueType,
  toImagineAgg: model => {
    if (model.filter?.filter == null) {
      return null;
    }
    return {
      type: 'filter',
      filter: model.filter.filter
    };
  }
};